module.exports = __webpack_public_path__ + "img/snmsung-pay.73ef2d4b.png";